:<template>
  <v-container
    :style="
      `background: ${$theme.background}; flex-direction: column;`
    "
    fluid
    class="molde pa-0 ma-0 "
  >
    <v-layout
      :style="
        `background: ${$theme.background}`
      "
      column
    >
      <div class="expande-horizontal centraliza">
        <v-flex v-if="isAndroid && !toolbar_off" xs12>
          <div class="expande-horizontal">
            <v-app-bar
              :app="$vuetify.breakpoint.smAndDown"
              :dark="dark"
              :light="!dark"
              :class="{
                'vitrify-content': true
              }"
              :fixed="$vuetify.breakpoint.smAndDown"
              class="elevation-0"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin-bottom: 0px; border-radius: 0px'
                  : 'border-radius: 0px;margin-bottom: 0px'
              "
            >
              <v-btn @click="drawer = !drawer" icon>
                <v-icon
                  size="19"
                  :color="templateMenuIconColor"
                  >mdi-menu</v-icon
                >
              </v-btn>

              <span
                @click="drawer = !drawer"
                :style="
                  `font-size: 12pt; cursor: pointer; color: ${
                    $route.path == '/gestordepedidos' ? 'white' : $theme.primary
                  }`
                "
                class="fonte not-selectable text-no-wrap text-lowercase fonteMini"
                >{{ title }}</span
              >
              <v-btn
                dark
                rounded
                color="green accent-3"
                class="fonte ml-2 elevation-0"
                @click="$refs.onboarding.open('dashboard')"
                v-if="false"
                small
              >
                <span class="fonteMini">guia</span>
                <v-icon class="ml-1" size="16">mdi-help-circle-outline</v-icon>
              </v-btn>

              <v-spacer></v-spacer>

              <div id="notifications-container" class="active-next-step">
                <v-menu offset-y left bottom :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      rounded
                      class="animate__animated animate__swing  elevation-0"
                      :color="
                        notificationsUnreadeds.length ? $theme.primary : 'grey'
                      "
                      v-on="on"
                    >
                      <span class="font-weight-bold">
                        {{ notificationsUnreadeds.length }}
                      </span>
                      <v-icon size="21" color="#f2f2f2"
                        >mdi-bell-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-card class="pa-3">
                    <v-list-item class="pa-0">
                      <v-avatar class="mr-3 elevation-1" color="#333">
                        <v-icon color="#f2f2f2">
                          mdi-bell-outline
                        </v-icon>
                      </v-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          Notificações
                        </v-list-item-title>
                        <span class="fonte fonteMini grey--text">
                          {{ notificationsUnreadeds.length }} Notificações
                          novas</span
                        >
                      </v-list-item-content>
                      <v-list-item-action>
                        <div class="column centraliza">
                          <v-switch
                            small
                            hide-details
                            class="fonte fonteMini"
                            :color="$theme.primary"
                            v-model="onlyUnreadeds"
                          >
                          </v-switch>
                          <span
                            style="cursor: pointer;"
                            @click="onlyUnreadeds = !onlyUnreadeds"
                            class="fonteMini fonte grey--text"
                          >
                            não lidas
                          </span>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                    <v-list
                      class="fonte"
                      v-if="notifications.length > 0"
                      style="max-height: 300px; overflow: auto;"
                    >
                      <template
                        v-for="(notification, i) in onlyUnreadeds
                          ? notificationsUnreadeds
                          : notifications"
                      >
                        <v-list-item
                          class="item-list-notification"
                          :key="notification._id"
                          v-if="onlyUnreadeds ? !notification.readed : true"
                          @click="abre_modal_view_notification(notification)"
                        >
                          <v-avatar size="31" class="mr-3" color="#333">
                            <v-icon :color="$theme.primary" size="21">
                              {{
                                getTypeLinkByTypeNotification(notification).icon
                              }}
                            </v-icon>
                          </v-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span
                                class=""
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                              >
                                {{
                                  getTypeLinkByTypeNotification(notification)
                                    .title
                                }}
                              </span>
                            </v-list-item-title>
                            <span
                              class="fonte grey--text fonteMini mt-1"
                              :class="{
                                'font-weight-bold': !notification.readed
                              }"
                            >
                              {{ notification.description }}
                            </span>
                            <div class="expande-horizontal">
                              <span
                                class="fonte fonteMini mt-1"
                                :style="`color: ${$theme.secondary}`"
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                {{ $moment(notification.created_at).fromNow() }}
                              </span>
                              <span
                                class="fonte fonteMini mt-1"
                                :style="`color: ${$theme.secondary}`"
                                v-if="notification.readed"
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                , foi lida
                                {{
                                  $moment(notification.readDate).format(
                                    "DD/MM/YY [às] HH:mm"
                                  )
                                }}
                              </span>
                              <span
                                class="fonte fonteMini mt-1"
                                :style="`color: ${$theme.secondary}`"
                                v-else
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                , não lida ainda.
                              </span>
                              <v-icon
                                class="ml-2"
                                color="green"
                                size="15"
                                v-if="!notification.readed"
                                >mdi-check</v-icon
                              >
                              <v-icon
                                class="ml-2"
                                color="green"
                                size="15"
                                v-if="notification.readed"
                                >mdi-check-all</v-icon
                              >
                            </div>
                          </v-list-item-content>
                          <!-- <v-list-item-action>
                            
                          </v-list-item-action> -->
                        </v-list-item>
                        <!-- <v-divider :key="`divider-${i}`"></v-divider> -->
                      </template>
                    </v-list>
                    <div
                      v-if="notifications.length === 0"
                      class="notifications-empty-container fonte expande-horizontal centraliza column"
                    >
                      <v-avatar class="mb-3" :color="$theme.primary">
                        <v-icon color="#f2f2f2">mdi-bell-outline</v-icon>
                      </v-avatar>
                      <span :style="`color: ${$theme.primary}`" class="fonte"
                        >Nada por aqui</span
                      >
                      <span class="text-center grey--text fonteMini fonte">
                        Novas notificações aparecerão aqui
                      </span>
                    </div>
                  </v-card>
                </v-menu>
              </div>

              <div id="options-container">
                <v-menu offset-y v-show="options" left bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-show="options && $vuetify.breakpoint.smAndDown"
                      icon
                      :color="$theme.secondary"
                      v-on="on"
                    >
                      <v-icon
                        :color="
                          $route.path == '/gestordepedidos'
                            ? 'white'
                            : $theme.primary
                        "
                        >mdi-dots-vertical</v-icon
                      >
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="item in options"
                      class="active-next-step"
                      :key="item.nome"
                      @click="() => item.action()"
                    >
                      <v-list-item-title class="fonte">{{
                        item.nome
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-app-bar>
          </div>
        </v-flex>
        <v-flex v-if="!isAndroid && !toolbar_off" xs12 md10>
          <div class="expande-horizontal">
            <v-app-bar
              dense
              app
              :dark="dark"
              :light="!dark"
              height="54"
              :color="dark ? '#111b21' : '#f7faf8'"
              :fixed="$vuetify.breakpoint.smAndDown"
              class="template-modern-appbar elevation-0"
            >
              <v-btn class="template-appbar-icon-btn" @click="drawer = !drawer" icon>
                <v-icon
                  size="19"
                  :color="templateMenuIconColor"
                  >mdi-menu</v-icon
                >
              </v-btn>

              <div class="template-appbar-breadcrumbs">
                <span
                  v-for="(rota, index) in rotas"
                  @click="$router.push(rota.path)"
                  :key="rota.path"
                  class="template-appbar-breadcrumb fonte-bold not-selectable text-no-wrap"
                  :class="{ active: index === rotas.length - 1 }"
                >
                  {{ rota.name }}
                  <v-icon
                    class="template-appbar-chevron"
                    :color="dark ? '#8ea39a' : '#7b9087'"
                    v-if="index < rotas.length - 1"
                    size="15"
                  >
                    mdi-chevron-right
                  </v-icon>
                </span>
              </div>
              <v-spacer></v-spacer>
              <div class="template-appbar-search">
                <slot name="toolbar-search"></slot>
              </div>
              <v-spacer></v-spacer>
              <!-- <span class="fonte text-capitalize grey--text fonteMini">
                {{ $moment().format("LLLL") }}
                <v-btn
                  rounded
                  color="green accent-3"
                  class="fonte ml-2 elevation-0"
                  @click="$refs.onboarding.open('dashboard')"
                  x-small
                  v-if="false"
                >
                  <span class="fonteMini">guia</span>
                  <v-icon class="ml-1" size="16"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </span> -->
              <v-spacer></v-spacer>

              <!-- Options desktop -->
              <div id="options-container" class="template-appbar-actions">
                <v-btn
                  small
                  v-for="item in options"
                  :color="dark ? '#1f8f55' : '#075e54'"
                  dark
                  class="template-appbar-action-btn elevation-0 active-next-step mr-1"
                  @click="item.action()"
                  :key="item.nome"
                >
                  <v-icon size="13" class="mr-1" color="#f2f2f2">
                    {{ item.icon }}
                  </v-icon>
                  <span
                    :style="`font-size: 9pt; color: #f2f2f2;`"
                    class="fonte fonteMini text-capitalize"
                    >{{ item.nome }}</span
                  >
                </v-btn>
              </div>

              <!-- Notificações -->
              <div id="notifications-container" class="template-appbar-notifications active-next-step">
                <v-menu offset-y left bottom :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      class="template-appbar-notification-btn elevation-0"
                      :color="
                        notificationsUnreadeds.length ? '#25D366' : dark ? '#26343c' : '#e8f3ee'
                      "
                      v-on="on"
                    >
                      <span class="font-weight-bold" :style="`color: ${notificationsUnreadeds.length ? '#08261c' : dark ? '#8ea39a' : '#667781'}`">
                        {{ notificationsUnreadeds.length }}
                      </span>
                      <v-icon size="21" :color="notificationsUnreadeds.length ? '#08261c' : dark ? '#8ea39a' : '#667781'"
                        >mdi-bell-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-card class="pa-3">
                    <v-list-item class="pa-0">
                      <v-avatar class="mr-3 elevation-1" color="#f2f2f2">
                        <v-icon color="#f2f2f2">
                          mdi-bell-outline
                        </v-icon>
                      </v-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          Notificações
                        </v-list-item-title>
                        <span class="fonte fonteMini grey--text">
                          {{ notificationsUnreadeds.length }} Notificações
                          novas</span
                        >
                      </v-list-item-content>
                      <v-list-item-action>
                        <div class="column centraliza">
                          <v-switch
                            small
                            hide-details
                            class="fonte fonteMini"
                            :color="$theme.primary"
                            v-model="onlyUnreadeds"
                          >
                          </v-switch>
                          <span
                            style="cursor: pointer;"
                            @click="onlyUnreadeds = !onlyUnreadeds"
                            class="fonteMini fonte grey--text"
                          >
                            não lidas
                          </span>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                    <v-list
                      class="fonte"
                      v-if="notifications.length > 0"
                      width="350"
                      style="max-height: 300px; overflow: auto;"
                    >
                      <template
                        v-for="(notification, i) in onlyUnreadeds
                          ? notificationsUnreadeds
                          : notifications"
                      >
                        <v-list-item
                          class="item-list-notification"
                          :key="notification._id"
                          v-if="onlyUnreadeds ? !notification.readed : true"
                          @click="abre_modal_view_notification(notification)"
                        >
                          <v-avatar size="31" class="mr-3" color="#f2f2f2">
                            <v-icon :color="$theme.primary" size="21">
                              {{
                                getTypeLinkByTypeNotification(notification).icon
                              }}
                            </v-icon>
                          </v-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span
                                class=""
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                              >
                                {{
                                  getTypeLinkByTypeNotification(notification)
                                    .title
                                }}
                              </span>
                            </v-list-item-title>
                            <span
                              class="fonte grey--text fonteMini mt-1"
                              :class="{
                                'font-weight-bold': !notification.readed
                              }"
                            >
                              {{ notification.description }}
                            </span>
                            <div class="expande-horizontal">
                              <span
                                class="fonte mt-1"
                                :style="`color: ${$theme.secondary}`"
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                {{
                                  $moment(notification.created_at).fromNow()
                                }}</span
                              >
                              <span
                                class="fonte mt-1"
                                :style="`color: ${$theme.secondary}`"
                                v-if="notification.readed"
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                , foi lida
                                {{
                                  $moment(notification.readDate).format(
                                    "DD/MM/YY [às] HH:mm"
                                  )
                                }}
                              </span>
                              <span
                                class="fonte fonteMini mt-1"
                                :style="`color: ${$theme.secondary}`"
                                v-else
                                :class="{
                                  'font-weight-bold': !notification.readed
                                }"
                                style="font-size: 6pt;"
                              >
                                , não lida ainda.
                              </span>
                              <v-icon
                                class="ml-2"
                                color="green"
                                size="15"
                                v-if="!notification.readed"
                                >mdi-check</v-icon
                              >
                              <v-icon
                                class="ml-2"
                                color="green"
                                size="15"
                                v-if="notification.readed"
                                >mdi-check-all</v-icon
                              >
                            </div>
                          </v-list-item-content>
                          <!-- <v-list-item-action>
                            
                          </v-list-item-action> -->
                        </v-list-item>
                        <!-- <v-divider :key="`divider-${i}`"></v-divider> -->
                      </template>
                    </v-list>
                    <div
                      v-if="notifications.length === 0"
                      class="notifications-empty-container fonte expande-horizontal centraliza column"
                    >
                      <v-avatar class="mb-3" :color="$theme.primary">
                        <v-icon color="#f2f2f2">mdi-bell-outline</v-icon>
                      </v-avatar>
                      <span :style="`color: ${$theme.primary}`" class="fonte"
                        >Nada por aqui</span
                      >
                      <span class="text-center grey--text fonteMini fonte">
                        Novas notificações aparecerão aqui
                      </span>
                    </div>
                  </v-card>
                </v-menu>
              </div>

              <!-- perfil do usuário -->
              <v-menu offset-y left bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    class="template-appbar-store-btn ml-1 elevation-0"
                    :color="dark ? '#182229' : '#ffffff'"
                    v-on="on"
                  >
                    <span
                      class="fonte-bold"
                      :style="`padding-top: 3px; font-size: 10pt; color: ${dark ? '#e9edef' : '#173b33'};`"
                    >
                      {{ getLoggedUser.tenant[0].nome.split(" ")[0] }}
                    </span>
                    <!-- <v-icon size="19" color="#333" class="ml-2"
                      >mdi-storefront</v-icon
                    > -->
                  </v-btn>
                </template>

                <v-list nav dense>
                  <v-list-item to="/logged-user">
                    <v-list-item-title>{{
                      getLoggedUser.nome
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="logout">
                    <v-list-item-title>sair</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- options mobile -->
              <v-menu offset-y v-show="options" left bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-show="options && $vuetify.breakpoint.smAndDown"
                    icon
                    :color="$theme.secondary"
                    v-on="on"
                  >
                    <v-icon :color="$theme.secondary">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list class="fonte">
                  <v-list-item
                    v-for="item in options"
                    :key="item.nome"
                    class="active-next-step"
                    @click="() => item.action()"
                  >
                    <v-list-item-title class="fonte">{{
                      item.nome
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-app-bar>
          </div>
        </v-flex>
      </div>

      <!-- Drawer desktop -->
      <v-navigation-drawer
        :mini-variant="!drawer"
        :expand-on-hover="false"
        v-if="$vuetify.breakpoint.lgAndUp"
        app
        :light="!dark"
        :dark="dark"
        :color="dark ? '#111b21' : '#e5e5e5'"
        class="drawer-roller-style"
        :class="{
          'vitrify-content': dark && $route.path === '/gestordepedidos',
          'drawer-color': $route.path !== '/gestordepedidos',
          'drawer-color-dark': dark && $route.path !== '/gestordepedidos'
        }"
        width="210"
        :value="true"
      >
        <v-list
          color="transparent"
          style="min-height: 100vh;"
          dense
          nav
          :light="!dark"
          :dark="dark"
        >
          <v-list-item
            style="min-height: 40px; margin-left: 0px; padding-left: 0px;"
            :class="{
              'white--text': dark,
              'black--text': !dark
            }"
            class="fonte"
            to="/logged-user"
          >
            <v-avatar size="32" rounded class="ml-1" v-if="getLoggedUser.profile_image">
              <img :src="getLoggedUser.profile_image" />
            </v-avatar>
            <v-avatar rounded size="40" v-else :color="$theme.secondary">
              <v-icon
                size="26"
                :color="
                  $theme.light
                    ? '#333'
                    : 'white'
                "
              >
                mdi-account-circle-outline
              </v-icon>
            </v-avatar>
            <v-list-item-content class="ml-2">
              <v-list-item-title v-if="getLoggedUser.nome" class="fonte">
                {{ getLoggedUser.nome.split(" ")[0] }}
              </v-list-item-title>
              <!-- <span class="fonteMini grey--text">
                {{ getLoggedUser.permissao.nome }}
              </span> -->
            </v-list-item-content>
          </v-list-item>

          <template v-for="(menu, index) in menus">
            <v-divider
              v-if="menu.name === 'divider' && menu.permission()"
              :key="`${menu.name}--${index}`"
            ></v-divider>
            <v-tooltip
              v-if="menu.name !== 'divider' && menu.permission()"
              :key="menu.name"
              right
              :disabled="drawer"
              content-class="drawer-menu-tooltip"
            >
              <template v-slot:activator="{ on, attrs }">
            <v-list-item
              :to="menu.route"
              class="mb-0"
              v-bind="attrs"
              v-on="on"
              :class="{
                'white--text':
                  dark ||
                  menu.route === $route.path,
                'black--text':
                  !dark &&
                  menu.route !== $route.path
              }"
              :active-class="menu.route === $route.path ? 'menuAtivoHome' : ''"
            >
              <v-icon
                size="23"
                class="ml-0 mr-3"
                :id="`menu-${menu.name.replaceAll(' ', '-')}`"
                :color="
                  menu.route === $route.path
                    ? 'white'
                    : dark
                      ? '#c9d7d0'
                      : '#555'
                "
              >
                {{ menu.icon }}
              </v-icon>
              <v-list-item-content>
                <v-list-item-title class="fonte">
                  <span class="fonte-bold drawer-menu-title">
                    {{ menu.name }}
                    
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle v-if="menu?.beta">
                  <v-chip color="orange" class="fonteMini fonte-bold" style="color: #333;" x-small>novo 🚀 </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
              </template>
              <span>{{ menu.name }}</span>
            </v-tooltip>
          </template>

          <v-list-item
            :class="{
              'grey--text': $route.path === '/gestordepedidos' ? true : false
            }"
            class="fonte grey--text fonteMini"
            v-if="false"
            to="/escolher-empresa"
          >
            <v-icon size="18" class="mr-1" color="orange">
              mdi-swap-horizontal
            </v-icon>
            <v-list-item-title>
              Trocar de empresa
            </v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            :class="{
              'grey--text': $route.path === '/gestordepedidos' ? true : false
            }"
            class="fonte pl-3 grey--text fonteMini"
            @click="logout"
          >
            <v-icon size="16" class="mr-2" color="red">
              mdi-exit-run
            </v-icon>
            <v-list-item-title>sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      
      <!-- Drawer Mobile -->
      <v-navigation-drawer
        v-else
        app
        v-model="drawer"
        class="drawer-roller-style"
        :light="!dark"
        :dark="dark"
        :color="dark ? '#111b21' : '#e5e5e5'"
        :class="{
          'vitrify-content': dark && $route.path === '/gestordepedidos',
          'drawer-color': $route.path !== '/gestordepedidos',
          'drawer-color-dark': dark && $route.path !== '/gestordepedidos'
        }"
      >
        <v-list
          color="transparent"
          style="min-height: 100vh;"
          dense
          nav
          :light="!dark"
          :dark="dark"
        >
          <v-list-item
            style="min-height: 50px; margin-left: 0px; padding-left: 0px;"
            :class="{
              'white--text': dark,
              'black--text': !dark
            }"
            class="fonte"
            to="/logged-user"
          >
            <v-avatar size="27" class="mr-2" v-if="getLoggedUser.profile_image">
              <v-img :src="getLoggedUser.profile_image"></v-img>
            </v-avatar>
            <v-avatar rounded size="40" v-else :color="$theme.secondary">
              <v-icon
                size="26"
                :color="
                  $theme.light
                    ? '#333'
                    : 'white'
                "
              >
                mdi-account-circle-outline
              </v-icon>
            </v-avatar>
            <v-list-item-content class="ml-2">
              <v-list-item-title v-if="getLoggedUser.nome" class="fonte">
                {{ getLoggedUser.nome.split(" ")[0] }}
              </v-list-item-title>
              <span class="fonteMini grey--text">
                {{ getLoggedUser.permissao.nome }}
              </span>
            </v-list-item-content>
          </v-list-item>

          <template v-for="(menu, index) in menus">
            <v-divider
              v-if="menu.name === 'divider' && menu.permission()"
              :key="`${menu.name}--${index}`"
            ></v-divider>
            <v-list-item
              v-if="menu.name !== 'divider' && menu.permission()"
              :to="menu.route"
              :key="menu.name"
              :class="{
                'white--text':
                  dark ||
                  menu.route === $route.path,
                'black--text':
                  !dark &&
                  menu.route !== $route.path
              }"
              :active-class="menu.route === $route.path ? 'menuAtivoHome' : ''"
            >
              <v-icon
                size="19"
                class="ml-1 mr-1"
                :id="`menu-${menu.name.replaceAll(' ', '-')}`"
                :color="
                  menu.route === $route.path
                    ? 'white'
                    : dark
                      ? '#c9d7d0'
                      : '#555'
                "
              >
                {{ menu.icon }}
              </v-icon>
              <v-list-item-content>
                <v-list-item-title class="fonte">
                  <span class="fonte" style="font-size: 9pt;">
                    {{ menu.name }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item
            :class="{
              'grey--text': $route.path === '/gestordepedidos' ? true : false
            }"
            class="fonte grey--text fonteMini"
            v-if="false"
            to="/escolher-empresa"
          >
            <v-icon size="18" class="mr-1" color="orange">
              mdi-swap-horizontal
            </v-icon>
            <v-list-item-title>
              Trocar de empresa
            </v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            :class="{
              'grey--text': $route.path === '/gestordepedidos' ? true : false
            }"
            class="fonte pl-3 grey--text fonteMini"
            @click="logout"
          >
            <v-icon size="16" class="mr-2" color="red">
              mdi-exit-run
            </v-icon>
            <v-list-item-title>sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main
        class="molde"
        :class="{
          'blacked-background': dark && $route.path == '/gestordepedidos'
        }"
        :style="
          `${$theme.background}`
        "
      >
        <!-- <div
          class="expande-horizontal centraliza"
          :style="
            `max-height: ${
              toolbar_off ? '100vh' : 'calc(100vh - 40px)'
            }; min-height: 95vh; border-radius: 6px;`
          "
        > -->
          <v-flex xs12 md12>
            <!-- <div style="border-radius: 6px;" class="expande-horizontal wrap"> -->
              <slot></slot>
            <!-- </div> -->
          </v-flex>
        <!-- </div> -->
      </v-main>
    </v-layout>
    <ModalOnboarding ref="onboarding" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalOnboarding from "./ModalOnboarding";
import { EventBus } from "@/main.js";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { onBackgroundMessage } from "firebase/messaging/sw";
export default {
  props: [
    "title",
    "options",
    "icon",
    "action",
    "origem",
    "rotas",
    "toolbar_off"
  ],
  data() {
    return {
      dark: false,
      drawer: false,
      onlyUnreadeds: false,
      transparency_routes: ["/dashboard", "/atendimento", "/gestordepedidos"],
      menus: [
        {
          icon: "mdi-view-dashboard-outline",
          name: "Dashboard",
          route: "/dashboard",
          permission: () =>
            this.get_permission_user["dashboard"]
        },
        {
          icon: "mdi-cash-register",
          name: "Caixa",
          route: "/atendimento",
          permission: () =>
            this.get_permission_user["vender"]
        },
        {
          icon: "mdi-arrow-decision",
          name: "Gestor de Vendas",
          beta: false,
          route: "/gestordepedidos",
          permission: () =>
            this.get_permission_user["gestor-de-pedidos"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-calendar-badge-outline",
          name: "Minha Agenda",
          beta: false,
          route: "/minha-agenda",
          permission: () =>
            this.get_permission_user["minha-agenda"]
        },
        {
          icon: "mdi-calendar-edit-outline",
          name: "Agenda",
          route: "/agenda",
          beta: false,
          permission: () =>
            this.get_permission_user["agenda"]
        },
        {
          icon: "mdi-truck-delivery-outline",
          name: "Entregas",
          route: "/entregas",
          beta: false,
          permission: () =>
            this.get_permission_user["fazer-entregas"]
        },
        {
          icon: "mdi-truck-outline",
          name: "Veículos",
          route: "/veiculos",
          beta: false,
          permission: () =>
            this.get_permission_user["veiculos"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-clipboard-list-outline",
          name: "Lista de compras",
          beta: false,
          route: "/lista-de-compras",
          permission: () =>
            this.get_permission_user["lista-de-compras"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-library-outline",
          name: "Produtos",
          route: "/insumos",
          permission: () =>
            this.get_permission_user["produtos"]
        },
        {
          icon: "mdi-account-circle-outline",
          name: "Clientes",
          route: "/clientes",
          permission: () =>
            this.get_permission_user["clientes"]
        },
        {
          icon: "mdi-storefront",
          name: "Gestão de Obras",
          route: "/obras",
          permission: () =>
            this.get_permission_user["gestao-de-obras"] ||
            this.get_permission_user["obras"]
        },
        {
          icon: "mdi-storefront-outline",
          name: "Unidades/Polos",
          route: "/unidades",
          permission: () =>
            this.get_permission_user["unidades"]
        },
        {
          icon: "mdi-card-account-phone-outline",
          name: "Contatos da Empresa",
          route: "/contatos-empresa",
          permission: () =>
            this.get_permission_user["contatos-empresa"]
        },
        {
          icon: "mdi-account-group-outline",
          name: "Colaboradores",
          route: "/funcionarios",
          permission: () =>
            this.get_permission_user["colaboradores"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-ballot-outline",
          name: "Contas",
          beta: false,
          route: "/invoices",
          permission: () =>
            this.get_permission_user["contas"]
        },
        {
          icon: "mdi-cash-sync",
          name: "Cobrança",
          beta: false,
          route: "/cobranca",
          permission: () =>
            this.get_permission_user["cobranca"]
        },
        // {
        //   icon: "mdi-receipt",
        //   name: "Relatório de contas",
        //   route: "/caixas",
        //   permission: () => this.get_permission_user["relatorios"]
        // },
        {
          name: "divider",
          permission: () => false
        },
        // {
        //   icon: "mdi-receipt-outline",
        //   name: "Histórico de vendas",
        //   route: "/transacoes",
        //   permission: () => this.get_permission_user["relatorios"]
        // },
        {
          icon: "mdi-receipt-text-check-outline",
          name: "Contabilidade",
          beta: false,
          route: "/acompanhamento-de-caixa",
          permission: () =>
            this.get_permission_user["contabilidade-de-caixas"]
        },
        {
          icon: "mdi-receipt-text-check-outline",
          name: "Relatório",
          beta: false,
          route: "/caixas",
          permission: () =>
            this.get_permission_user["relatorio-de-contabilidade"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-lock-outline",
          name: "Permissões",
          route: "/permissoes",
          permission: () =>
            this.get_permission_user["permissoes"]
        },
        // {
        //   icon: "mdi-storefront-outline",
        //   name: "Gerenciar Empresas",
        //   route: "/marketplaces",
        //   permission: () => this.getLoggedUser.admin
        // },
        {
          icon: "mdi-whatsapp",
          name: "IntraWhats",
          route: "/whatsapp-atendimento",
          permission: () => this.canOpenWhatsappMenu()
        },
        {
          icon: "mdi-cog-outline",
          name: "Configurações",
          route: "/configurar-loja",
          permission: () => this.getLoggedUser.admin
        }
      ],
      notifications: [],
      isAndroid: false,
      miniVariant: true
    };
  },
  watch: {
    drawer(val) {
      localStorage.setItem("drawer", val);
    }
  },
  components: {
    ModalOnboarding
  },
  computed: {
    ...mapGetters([
      "getLoggedUser",
      "get_permission_user",
      "get_permission_plan"
    ]),
    notificationsUnreadeds() {
      return this.notifications.filter(n => !n.readed);
    },
    templateMenuIconColor() {
      return this.dark ? "#e9edef" : "#333";
    }
  },
  methods: {
    ...mapActions(["logout"]),
    canOpenWhatsappMenu() {
      const user = this.getLoggedUser || {};
      const permission = user.permissao || {};
      const permissions = {
        ...(this.get_permission_user || {}),
        ...(permission.permissoes || {}),
        ...(permission.permissions || {})
      };
      const permissionName = String(permission.nome || permission.name || "").toLowerCase();
      return Boolean(
        user.admin ||
        user.is_admin ||
        permissions["whatsapp-atendimento"] ||
        permissions.intrawhats ||
        permissions.whatsapp ||
        permissionName.includes("adm") ||
        permissionName.includes("admin")
      );
    },
    applyTemplateTheme(dark = localStorage.dark === "true") {
      const nextDark = Boolean(dark);
      this.dark = nextDark;
      this.$theme.dark = nextDark;
      this.$theme.light = !nextDark;
      this.$theme.background = nextDark ? "#0b141a" : "var(--background-base)";
      this.$theme.icon_drawer = nextDark ? "#c9d7d0" : "#333";
      if (this.$vuetify && this.$vuetify.theme) {
        this.$vuetify.theme.dark = nextDark;
      }
      this.$nextTick(() => this.$forceUpdate());
    },
    handleThemeChanged(payload = {}) {
      const hasDarkPayload = Object.prototype.hasOwnProperty.call(payload, "dark");
      this.applyTemplateTheme(hasDarkPayload ? payload.dark : localStorage.dark === "true");
    },
    handleThemeStorageChange(event) {
      if (event.key === "dark") {
        this.applyTemplateTheme(event.newValue === "true");
      }
    },
    getLinkNotify(notification) {
      const types = {
        invoice_payment: {
          title: "Pagamento de conta",
          link: `/invoice?t_id=${notification.payload._id}`
        },
        new_comment: {
          title: "Novo comentário",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        employee_balance_added: {
          title: "Salário adicionado manualmente",
          link: `/funcionarios?f_id=${
            notification.client ? notification.client._id : ""
          }&type=salario&e_id=${notification.payload._id}`
        },
        employee_balance_withdraw: {
          title: "Vale emitido",
          link: `/funcionarios?f_id=${notification.payload._id}&type=vale&extra=${notification.payload._id}`
        },
        sale_updated: {
          title: "Venda atualizada",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        stock_up: {
          title: "Estoque aumentado",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        stock_down: {
          title: "Estoque diminuido",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        stock_low: {
          title: "Estoque baixo",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        box_closed: {
          title: "Caixa fechado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        box_opened: {
          title: "Caixa aberto",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        new_payment: {
          title: "Pagamento Recebido",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        new_comment_external_movimentation: {
          title: "Novo comentário",
          link: `/agenda?t_id=${notification.payload._id}`
        },
        new_external_movimentation: {
          title: "Novo agendamento",
          link: `/agenda?e_id=${notification.payload._id}`
        },
        new_external_movimentation_viewed: {
          title: "O agendamento foi visualizado",
          link: `/agenda?e_id=${notification.payload._id}`
        },
        external_movimentation_updated: {
          title: "Um agendamento foi atualizado",
          link: `/minha-agenda?e_id=${notification.payload._id}`
        },
        delivery_confirmation: {
          title: "Confirmação de entrega",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        delivery_confirmation_whatsapp_queued: {
          title: "Confirmação de entrega enviada",
          link: `/whatsapp-atendimento`
        },
        delivery_confirmation_whatsapp_pending: {
          title: "Confirmação de entrega pendente",
          link: `/gestordepedidos/venda/${notification.payload.transaction_id || notification.payload._id}`
        },
        assembly_offer_whatsapp_pending: {
          title: "Oferta de montagem pendente",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        collection_whatsapp_pending: {
          title: "Cobrança pendente",
          link: `/cobranca`
        },
        collection_contact_registered: {
          title: "Contato de cobrança registrado",
          link: `/cobranca`
        },
        whatsapp_delivery_response: {
          title: "Resposta sobre entrega",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_assembly_declined: {
          title: "Montagem recusada",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_assembly_requested: {
          title: "Montagem solicitada",
          link: `/agenda?e_id=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_approval_response: {
          title: "Resposta de aprovação",
          link: `/gestordepedidos/venda/${notification.payload.transaction_id || notification.payload._id}`
        },
        whatsapp_collection_response: {
          title: "Resposta de cobrança",
          link: `/cobranca`
        },
        whatsapp_company_contact_notice: {
          title: "Aviso de contato da empresa",
          link: `/whatsapp-atendimento`
        },
        transaction_unsigned: {
          title: "Registro da conferência de caixa foi Cancelado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        transaction_signed: {
          title: "Registro da conferência de caixa foi Aprovado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        seller_signup: {
          title: "Um vendedor se cadastrou",
          link: `https://erp.stonepro.com.br/#/sellers?c_id=${notification.payload._id}`
        },
        "signature-flow-initiated": {
          title: "Um novo cliente se cadastrou",
          link: `https://erp.stonepro.com.br/#/funcionarios?c_id=${notification.payload._id}`
        },
        "signature-flow-progress": {
          title: "Um cliente criou sua loja",
          link: `https://erp.stonepro.com.br/#/funcionarios?c_id=${notification.payload._id}`
        }
      };
      if (String(notification.type || "").startsWith("whatsapp_template_")) {
        return {
          title: "Mensagem automática",
          link: `/whatsapp-atendimento`
        };
      }
      return types[notification.type] || {
        title: notification.type || "Notificação",
        link: "/dashboard"
      };
    },
    abre_modal_view_notification(notify) {
      if (!notify.readed) {
        this.markNotificationAsReaded(notify);
      }
      const route = this.getLinkNotify(notify);
      this.$router.push(route.link);
    },
    getIconNotification(type) {
      const types = {
        new_comment: "mdi-comment-text-outline",
        new_sale: "mdi-cash-register",
        sale_updated: "mdi-satellite-variant",
        stock_low: "mdi-trending-down",
        stock_down: "mdi-basket-minus-outline",
        stock_up: "mdi-basket-plus-outline"
      };
      return types[type];
    },
    getTypeLinkByTypeNotification(notification) {
      const types = {
        invoice_payment: {
          title: "Lançamento de caixa",
          icon: "mdi-receipt-text-check-outline"
        },
        new_comment: {
          title: "Novo comentário",
          icon: "mdi-comment-text-outline"
        },
        employee_balance_added: {
          title: "Salário adicionado manualmente",
          icon: "mdi-account-plus-outline"
        },
        employee_balance_withdraw: {
          title: "Vale emitido",
          icon: "mdi-account-minus-outline"
        },
        sale_updated: {
          title: "Venda atualizada",
          icon: "mdi-cash-register"
        },
        stock_up: {
          title: "Estoque aumentado",
          icon: "mdi-cart-arrow-up"
        },
        stock_down: {
          title: "Estoque diminuido",
          icon: "mdi-cart-arrow-down"
        },
        stock_low: {
          title: "Estoque baixo",
          icon: "mdi-trending-down"
        },
        box_closed: {
          title: "Caixa fechado",
          icon: "mdi-cash-register"
        },
        box_opened: {
          title: "Caixa aberto",
          icon: "mdi-cash-register"
        },
        new_payment: {
          title: "Pagamento",
          icon: "mdi-cash-register"
        },
        new_comment_external_movimentation: {
          title: "Novo comentário",
          icon: "mdi-comment-text-outline"
        },
        new_external_movimentation: {
          title: "Novo agendamento",
          icon: "mdi-calendar-clock"
        },
        new_external_movimentation_viewed: {
          title: "O agendamento foi visualizado",
          icon: "mdi-calendar-clock"
        },
        external_movimentation_updated: {
          title: "Um agendamento foi atualizado",
          icon: "mdi-calendar-clock"
        },
        delivery_confirmation: {
          title: "Confirmação de entrega",
          icon: "mdi-truck-delivery-outline"
        },
        delivery_confirmation_whatsapp_queued: {
          title: "Confirmação de entrega enviada",
          icon: "mdi-whatsapp"
        },
        delivery_confirmation_whatsapp_pending: {
          title: "Confirmação de entrega pendente",
          icon: "mdi-alert-circle-outline"
        },
        assembly_offer_whatsapp_pending: {
          title: "Oferta de montagem pendente",
          icon: "mdi-tools"
        },
        collection_whatsapp_pending: {
          title: "Cobrança pendente",
          icon: "mdi-cash-clock"
        },
        collection_contact_registered: {
          title: "Contato de cobrança registrado",
          icon: "mdi-note-edit-outline"
        },
        whatsapp_delivery_response: {
          title: "Resposta sobre entrega",
          icon: "mdi-truck-check-outline"
        },
        whatsapp_assembly_declined: {
          title: "Montagem recusada",
          icon: "mdi-tools"
        },
        whatsapp_assembly_requested: {
          title: "Montagem solicitada",
          icon: "mdi-tools"
        },
        whatsapp_approval_response: {
          title: "Resposta de aprovação",
          icon: "mdi-check-decagram-outline"
        },
        whatsapp_collection_response: {
          title: "Resposta de cobrança",
          icon: "mdi-cash-sync"
        },
        whatsapp_company_contact_notice: {
          title: "Aviso de contato da empresa",
          icon: "mdi-whatsapp"
        },
        transaction_unsigned: {
          title: "Registro da conferência de caixa foi Cancelado",
          icon: "mdi-calendar-clock"
        },
        transaction_signed: {
          title: "Registro da conferência de caixa foi Aprovado",
          icon: "mdi-success"
        },
        seller_signup: {
          title: "Um vendedor se cadastrou",
          icon: "mdi-account-plus-outline"
        },
        "signature-flow-initiated": {
          title: "Um novo cliente se cadastrou",
          icon: "mdi-account-plus-outline"
        },
        "signature-flow-progress": {
          title: "Um cliente criou sua loja",
          icon: "mdi-account-plus-outline"
        }
      };
      if (String(notification.type || "").startsWith("whatsapp_template_")) {
        return { title: "Mensagem automática", icon: "mdi-whatsapp" };
      }
      if (!types[notification.type])
        return { title: notification.type, icon: "help_outline" };
      return types[notification.type];
    },
    getNotificationDescription(type) {
      const types = {
        new_comment: "Novo comentário",
        new_sale: "Nova venda",
        sale_updated: "Venda atualizada",
        stock_low: "Estoque baixo",
        stock_up: "Entrada de estoque",
        stock_down: "Saída de estoque"
      };
      return types[type];
    },
    listNotifications() {
      this.$run("notifications/list-my-notifications").then(res => {
        this.notifications = res.data;
      });
    },
    markNotificationAsReaded(notification) {
      this.$run("notifications/mark-as-readed", { _id: notification._id }).then(
        res => {
          this.listNotifications();
        }
      );
    },
    goBack() {
      if (this.action !== undefined) {
        this.action();
      } else {
        this.$router.go(-1);
      }
    },
    notification_sound() {
      const audio = new Audio("call_in.mp3");
      audio.play();
    }
  },
  created() {
    this.drawer = !this.isAndroid;
    // this.listNotifications();
    this.isAndroid =
      navigator.userAgent.match(/Android/i) ||
      this.$vuetify.breakpoint.smAndDown;

    let cordova = window.cordova || false;
    const self = this;
    if (cordova) {
      cordova.plugins.firebase.messaging
        .requestPermission({ forceShow: false })
        .then(function() {
          console.log("Push messaging is allowed");
          cordova.plugins.firebase.messaging
            .getToken()
            .then(function(token) {
              self.$db.ref(`pn/${self.getLoggedUser._id}`).set({
                token: token,
                user: self.getLoggedUser._id
              });
            })
            .catch(function(err) {
              alert(err);
            });
        });
      StatusBar.backgroundColorByHexString(this.$theme.secondary);
    }
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    } else {
      this.drawer = localStorage.getItem("drawer") === "true";
    }
  },
  mounted() {
    this.applyTemplateTheme();
    EventBus.$on("theme:changed", this.handleThemeChanged);
    window.addEventListener("storage", this.handleThemeStorageChange);
    if (!sessionStorage.nt && this.$route.path !== '/dashboard') {
      if (Notification.permission === "granted") {
        sessionStorage.nt = "ok";
        const messaging = getMessaging();
        getToken(messaging, {
          vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY
        }).then(currentToken => {
          if (currentToken) {
            this.$run("notifications/register-token", {
              notification_token: currentToken
            }).catch(res => {
              console.log("erro no token", res);
            });
          } else {
            alert(
              "você recusou o envio de notificações, para receber nossos fluxos de notificação, acesse as configurações do seu navegador e permita o envio de notificações."
            );
          }
          onMessage(messaging, payload => {
            const { data } = payload;
            this.listNotifications();
            this.notification_sound();
          });
        });
      } else {
        Notification.requestPermission()
          .then(async permission => {
            if (permission === "granted") {
              const messaging = getMessaging();
              getToken(messaging, {
                vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY
              }).then(currentToken => {
                if (currentToken) {
                  this.$run("notifications/register-token", {
                    notification_token: currentToken
                  })
                    .then(() => {
                      sessionStorage.nt = "ok";
                    })
                    .catch(res => {
                      console.log("erro no token", res);
                    });
                } else {
                  alert(
                    "você recusou o envio de notificações, para receber nossos fluxos de notificação, acesse as configurações do seu navegador e permita o envio de notificações."
                  );
                }
                onMessage(messaging, payload => {
                  this.listNotifications();
                  this.notification_sound();
                });
              });
            }
          })
          .catch(err => {
            console.log("wtf", err);
          });
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("theme:changed", this.handleThemeChanged);
    window.removeEventListener("storage", this.handleThemeStorageChange);
  }
};
</script>

<style>
.molde,
.molde .v-application,
.molde .v-list-item__subtitle,
.molde .v-btn,
.molde .v-chip,
.molde .fonte,
.molde .fonteMini,
.molde .fonte-mini,
.molde input,
.molde textarea {
  font-family: "Inter", "Myriad Pro Regular", Arial, sans-serif !important;
}

.molde h1,
.molde h2,
.molde h3,
.molde h4,
.molde h5,
.molde h6,
.molde .v-toolbar__title,
.molde .v-list-item__title,
.molde .font-weight-bold,
.molde .fonte-bold {
  font-family: "Poppins", "Inter", "Myriad Pro Bold", Arial, sans-serif !important;
}

.molde .v-app-bar .fonte,
.molde .v-app-bar .fonte-bold {
  font-family: "Poppins", "Inter", Arial, sans-serif !important;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.molde .v-list-item__subtitle,
.molde .notifications-empty-container,
.molde .item-list-notification span:not(.font-weight-bold) {
  font-family: "Inter", "Myriad Pro Regular", Arial, sans-serif !important;
}

.drawer-color {
  background: #e5e5e5;
}
.drawer-color-dark {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, 0.08), transparent 32%),
    #111b21 !important;
}
.drawer-roller-style {
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.10) !important;
}
.drawer-color-dark.drawer-roller-style {
  border-right: 1px solid #26343c !important;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.34) !important;
}
.drawer-roller-style .v-list-item {
  border-radius: 12px !important;
  margin: 2px 8px !important;
  min-height: 38px !important;
  overflow: hidden;
}
.drawer-roller-style .v-list-item__icon,
.drawer-roller-style .v-icon {
  margin-right: 10px !important;
}
.theme--dark.drawer-roller-style .v-list-item:not(.menuAtivoHome):not(.v-list-item--active) .v-icon {
  color: #c9d7d0 !important;
}
.theme--dark.drawer-roller-style .v-list-item:not(.menuAtivoHome):not(.v-list-item--active):hover .v-icon {
  color: #eef4f1 !important;
}
.drawer-roller-style .menuAtivoHome,
.drawer-roller-style .v-list-item--active {
  background: linear-gradient(135deg, #075e54, #128C7E) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
}
.drawer-roller-style .menuAtivoHome .v-icon,
.drawer-roller-style .v-list-item--active .v-icon {
  color: #ffffff !important;
}
.drawer-roller-style.v-navigation-drawer--mini-variant .v-list-item {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 40px !important;
  min-width: 40px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 40px !important;
}
.drawer-roller-style.v-navigation-drawer--mini-variant .menuAtivoHome,
.drawer-roller-style.v-navigation-drawer--mini-variant .v-list-item--active {
  background-size: 100% 100% !important;
  left: auto !important;
  max-width: 40px !important;
  min-width: 40px !important;
  right: auto !important;
  transform: none !important;
  width: 40px !important;
}
.drawer-roller-style.v-navigation-drawer--mini-variant .v-list-item::before {
  border-radius: 12px !important;
  inset: 0 !important;
}
.drawer-roller-style.v-navigation-drawer--mini-variant .v-list-item .v-icon {
  flex: 0 0 auto;
  margin-left: 0 !important;
  margin-right: 0 !important;
  transform: none !important;
  width: 24px !important;
}
.drawer-roller-style.v-navigation-drawer--mini-variant .v-list-item__content {
  display: none !important;
  flex: 0 0 0 !important;
  max-width: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
}
.drawer-menu-title {
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em;
  line-height: 1.15;
}
.v-navigation-drawer--mini-variant .drawer-menu-title {
  opacity: 0;
  pointer-events: none;
}
.drawer-menu-tooltip {
  background: #111b21 !important;
  border: 1px solid rgba(155, 231, 189, 0.22);
  border-radius: 12px !important;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.25);
  color: #e9edef !important;
  font-family: "Inter", Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 11px;
}
.template-modern-appbar {
  border-bottom: 1px solid rgba(7, 80, 89, 0.10) !important;
  box-shadow: 0 10px 28px rgba(7, 80, 89, 0.08) !important;
  padding: 0 10px !important;
  z-index: 6 !important;
}
.template-modern-appbar::after {
  content: "";
  position: absolute;
  inset: auto 18px 0 18px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(37, 211, 102, 0.26), transparent);
}
.template-modern-appbar-dark {
  border-bottom-color: rgba(155, 231, 189, 0.10) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22) !important;
}
.template-appbar-icon-btn,
.template-appbar-notification-btn,
.template-appbar-store-btn {
  border-radius: 14px !important;
  height: 38px !important;
  min-width: 38px !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.template-appbar-icon-btn {
  background: rgba(37, 211, 102, 0.10) !important;
  margin-right: 10px !important;
}
.template-modern-appbar-dark .template-appbar-icon-btn {
  background: rgba(37, 211, 102, 0.12) !important;
}
.template-menu-icon {
  transition: color 0.18s ease, transform 0.18s ease;
}
.template-modern-appbar-dark .template-menu-icon,
.theme--dark .template-menu-icon {
  color: #e9edef;
}
.template-appbar-icon-btn:hover,
.template-appbar-notification-btn:hover,
.template-appbar-store-btn:hover,
.template-appbar-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(7, 80, 89, 0.12) !important;
}
.template-appbar-breadcrumbs {
  align-items: center;
  display: flex;
  min-width: 0;
  overflow: hidden;
  padding: 0 8px;
}
.template-appbar-breadcrumb {
  align-items: center;
  color: #667781;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  gap: 4px;
  letter-spacing: -0.01em;
  line-height: 1;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  transition: color 0.18s ease;
}
.template-appbar-breadcrumb.active {
  color: #075e54;
  font-size: 14px;
  font-weight: 800;
}
.template-modern-appbar-dark .template-appbar-breadcrumb {
  color: #8ea39a;
}
.template-modern-appbar-dark .template-appbar-breadcrumb.active {
  color: #e9edef;
}
.template-appbar-chevron {
  flex: 0 0 auto;
  margin: 0 3px;
}
.template-appbar-search {
  align-items: center;
  display: flex;
  flex: 1 1 320px;
  justify-content: center;
  max-width: 520px;
  min-width: 0;
}
.template-appbar-search > * {
  max-width: 100%;
}
.template-appbar-actions {
  align-items: center;
  display: flex;
  gap: 6px;
  max-width: 42vw;
  overflow: hidden;
}
.template-appbar-action-btn {
  border-radius: 999px !important;
  height: 34px !important;
  letter-spacing: -0.01em;
  padding: 0 12px !important;
  text-transform: none !important;
}
.template-appbar-notifications {
  margin-left: 8px;
}
.template-appbar-notification-btn {
  gap: 3px;
  padding: 0 10px !important;
}
.template-appbar-store-btn {
  border: 1px solid rgba(7, 80, 89, 0.10) !important;
  box-shadow: 0 10px 26px rgba(7, 80, 89, 0.08) !important;
  padding: 0 13px !important;
  text-transform: none !important;
}
.template-modern-appbar-dark .template-appbar-store-btn {
  border-color: rgba(155, 231, 189, 0.10) !important;
  box-shadow: none !important;
}
@media(max-width: 1264px) {
  .template-appbar-actions {
    max-width: 28vw;
  }
  .template-appbar-action-btn span {
    display: none;
  }
  .template-appbar-action-btn {
    min-width: 34px !important;
    padding: 0 9px !important;
  }
}
@media(max-width: 960px) {
  .template-modern-appbar {
    padding: 0 6px !important;
  }
  .template-appbar-breadcrumb:not(.active) {
    display: none;
  }
  .template-appbar-search {
    display: none;
  }
}
.centraliza-tudo {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.molde {
  display: flex;
  width: 100%;
  border-radius: 6px;
}

.v-navigation-drawer__content::-webkit-scrollbar {
  width: 1px; /* width of the entire scrollbar */
}

.v-navigation-drawer__content::-webkit-scrollbar-track {
  background: rgb(122, 122, 122); /* color of the tracking area */
  border-radius: 6px;
}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: #e5e7e8; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
}
.notifications-empty-container {
  display: flex;
  width: 300px;
  border-radius: 6px;
  min-height: 300px;
  background: #fff;
}
.item-list-notification {
  border-radius: 6px;
  border: 1px solid #f2f2f2;
  margin-bottom: 10px;
  padding-right: 15px;
  padding: 6px;
}
.v-navigation-drawer__border {
    display: none !important;
  }
  .blacked-background {
    background: rgba(0, 0, 0, 0.2);
  }
</style>
